module.exports = __webpack_public_path__ + "img/ant-cloud.32d0311f.svg";